import { render, staticRenderFns } from "./StatusHero.vue?vue&type=template&id=6227061e&"
import script from "./StatusHero.vue?vue&type=script&lang=js&"
export * from "./StatusHero.vue?vue&type=script&lang=js&"
import style0 from "./StatusHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports